import { Box } from '@mui/material';

const MenuItemContent = ({
  icon,
  fragments,
  iconWidth,
  mobileWithIcon = true,
}) => (
  <Box
    id="box-menu-item-content-generic-dropdown"
    sx={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: icon && mobileWithIcon ? 1 : 0,
      flexShrink: 1,
      minWidth: 0,
      width: '100%',
      color: 'inherit',
    }}
  >
    {icon && mobileWithIcon && (
      <Box
        id="box-menu-item-icon-generic-dropdown"
        sx={{
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          height: '0px',
          alignSelf: 'center',
          width: iconWidth,
          minWidth: iconWidth,
          color: 'inherit',
          transition: 'color 0.2s ease',
        }}
      >
        {typeof icon === 'string' ? (
          <img
            id="img-menu-item-icon-generic-dropdown"
            src={icon}
            alt="icon"
            style={{
              width: '100%',
              height: 'auto',
              display: 'block',
            }}
          />
        ) : (
          icon
        )}
      </Box>
    )}

    <Box
      id="box-menu-item-text-container-generic-dropdown"
      sx={{
        fontSize: { xs: 16, md: 14, xl: 16 },
        lineHeight: 1.4375,
        color: 'inherit',
        fontFamily: 'Open Sans, sans-serif',
        whiteSpace: 'normal',
        overflow: 'visible',
        textOverflow: 'unset',
        display: 'block',
        flex: 1,
        minWidth: 0,
        alignSelf: 'center',
      }}
    >
      {fragments.map((frag, i) => (
        <Box
          key={i}
          id={`span-menu-item-fragment-${i}-generic-dropdown`}
          component="span"
          sx={{
            fontWeight: frag.bold ? 'bold' : 'normal',
            ml: i === 0 ? 0 : 0.5,
            display: 'inline-block',
            color: 'inherit',
            transition: 'color 0.2s ease',
          }}
        >
          {frag.text}
        </Box>
      ))}
    </Box>
  </Box>
);

export default MenuItemContent;
